import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide06Timeline({
  index
}: SlideProps) {
  return <InteriorSlide surface data-id="element-128" data-mp="jpyq2ksiyej8">
      <SlideHeader eyebrow="What Is a Teaser?" data-id="element-129" data-mp="omp6j988rc56">
        The teaser creates fast attention and curiosity
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-130" data-mp="snisvy61civy">
        <div className="flex-1 space-y-8" data-id="element-131" data-mp="xmc4tm5oc1u0">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-132" data-mp="12edfj3n71khx">
            A teaser is a short, interactive awareness experience. It is
            designed to be completed quickly and should make the HCP want to
            continue into the deeper campaign content.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-black/5" data-id="element-133" data-mp="1axtzzamtaw09">
            <h3 className="text-sm font-bold uppercase tracking-wider text-[var(--brand)] mb-4" data-id="element-134" data-mp="1tx7ze83b8yy5">
              Teaser Elements
            </h3>
            <ul className="space-y-3" data-id="element-135" data-mp="1ox3iwi2ek47x">
              {['Opening question', 'Quiz or poll', 'Peer comparison', 'Short brand message', 'CTA to trailer / microsite'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[var(--fg)] font-medium" data-id="element-136" data-mp="fp062u2i7rzt" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-[var(--brand)]" data-id="element-137" data-mp="knjx38vyftz1" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-6 pt-4 border-t border-black/5 flex items-center gap-3" data-id="element-138" data-mp="axrwny16c6mn">
              <span className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-139" data-mp="3t3n2f7zlh6k7">
                Typical Length:
              </span>
              <span className="bg-[var(--surface)] text-[var(--brand)] px-3 py-1 rounded-full text-sm font-bold" data-id="element-140" data-mp="11ow2wlz0g1t">
                ~30 seconds
              </span>
            </div>
          </motion.div>
        </div>

        {/* Mobile Mockup */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-shrink-0 w-[300px] relative" data-id="element-141" data-mp="1hevlcviqkw1n">
          <div className="absolute -inset-6 bg-[var(--brand)]/10 rounded-[3rem] blur-2xl" data-id="element-142" data-mp="31xpixuuoascm" />
          <img src="https://cdn.magicpatterns.com/uploads/svztb1kJdjc5SzC2XYofw9/Screenshot_2026-06-29_at_13.02.38.png" alt="Teaser mobile experience example" className="w-full h-auto rounded-[2.5rem] shadow-2xl border-4 border-white relative z-10" data-id="element-143" data-mp="3glsudjrhiw8t" />
        </motion.div>
      </div>
    </InteriorSlide>;
}